import type { TDisplayColumnData } from 'components/data/types';
import {
  CampaignFilter,
  SimpleAssetFilter,
  SiteFilter,
  WorkOrderComponentFilter,
} from 'components/DataTable/customFilters';
import type { CustomFilterDropdownProps } from 'horizon/types/TableColumnDef';

import { atlasWorkCampaign } from '../workOrders';

import { workOrderComponent, workOrderSites, workOrderTurbines } from './taskAssets';

export const WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP =
  'Set Site filter before setting Turbine filter.';

export const workOrderSitesColumn = (): TDisplayColumnData => ({
  ...workOrderSites,
  excludeFromServerFilter: true,
  filterDropdown: (props: CustomFilterDropdownProps) => <SiteFilter {...props} />,
});

export const workOrderCampaignColumn = (): TDisplayColumnData => ({
  ...atlasWorkCampaign,
  filterDropdown: (props: CustomFilterDropdownProps) => <CampaignFilter {...props} />,
});

export const workOrderTurbinesColumn = (): TDisplayColumnData => ({
  ...workOrderTurbines,
  excludeFromServerFilter: true,
  requiresSiteFilter: true,
  requiresSiteFilterTooltip: WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP,
  filterDropdown: (props: CustomFilterDropdownProps) => (
    <SimpleAssetFilter
      assetTypeName="Turbine"
      requireSiteFilter
      requireSiteFilterTooltip={WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP}
      {...props}
    />
  ),
});

export const workOrderComponentColumn = (): TDisplayColumnData => ({
  ...workOrderComponent,
  allKeys: ['asset', 'componentType'],
  excludeFromServerFilter: true,
  filterDropdown: (props: CustomFilterDropdownProps) => <WorkOrderComponentFilter {...props} />,
});
